var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('li',[_c('img',{attrs:{"src":_vm.image_src}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.destination)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }